<template>
  <div class="container-fluid">
    <b-container>
      <b-row>
        <b-col>
          <GeneralData></GeneralData>
        </b-col>

        <div style="border-right: 1px solid #e6e6e6"></div>
        
        <b-col>
          <ChangePassword></ChangePassword>
        </b-col>
      </b-row>
    </b-container>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import GeneralData from "./GeneralData.vue";
import ChangePassword from "./ChangePassword.vue";

export default {
  components: {
    GeneralData,
    ChangePassword
  }
};
</script>

<style lang="scss">
</style>